import { withInstall } from '@code-monkey-ui/utils'
import Result from './src/result.vue'

export const ElResult = withInstall(Result)

export default ElResult

export * from './src/result'
